module.exports = __webpack_public_path__ + "img/scene5-4.40688d94.png";